export enum InterceptionAttribute {
  LastLine = 3041,
}
